module.exports = __webpack_public_path__ + "img/in-inverted.c1643ceb.svg";